import { config } from "../config";
import { Message } from "../types/chat";

interface SendQuestionParams {
  question: string;
  messages: Message[];
  dynamicRoute?: string | null;
  location: { pathname: string };
}

export function useChatAPI() {
  const apiUrl = config.API_URL.replace(/\/+$/, "");
  const authToken = config.AUTH_TOKEN || "gestor_formacao_token";

  const sendQuestion = async ({ question, messages, dynamicRoute, location }: SendQuestionParams): Promise<Message> => {
    const MAX_TURNS = 6;
    const history = [...messages, { text: question, sender: "user" }]
      .slice(-MAX_TURNS)
      .map(m => ({ role: m.sender === "user" ? "user" : "bot", text: m.text }));

    let endpointPath = "/chat/public";
    if (dynamicRoute) endpointPath = dynamicRoute;
    else if (location.pathname === "/socorro") endpointPath = "/chat/socorro";

    const response = await fetch(`https://chatbot.forinsia.com${endpointPath}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${authToken}`,
      },
      body: JSON.stringify({ question, history }),
    });

    const text = await response.text();
    const data = text ? JSON.parse(text) : {};
    const answerText =
      data.answer ?? data.message ?? data.raw ?? "Desculpe, nao consegui processar sua pergunta.";

    return {
      id: Date.now() + 1,
      text: answerText,
      sender: "bot",
      timestamp: new Date().toLocaleTimeString(),
      cached: data.cached || false,
      classification: data.classification || null,
      debug: data.debug || null,
      sources: data.sources || null,
    };
  };

  return { sendQuestion };
}